/* eslint-disable react/no-danger */
/* eslint-disable import/no-unresolved */
import { Helmet } from 'react-helmet';
import { useLocation } from '@reach/router';
import { graphql, useStaticQuery } from 'gatsby';
import { usePageLocale } from '../hooks/usePageLocale';

export const Seo = ({ seoTitle, seoDescription, seoImage }) => {
  const { pathname } = useLocation();

  const { locale } = usePageLocale();
  const data = useStaticQuery(graphql`
    {
      datoCmsMisc {
        immagineOpengraphDefault {
          url
        }
      }
    }
  `);
  const { url } = data.datoCmsMisc.immagineOpengraphDefault;
  const seoTitleString =
    seoTitle === undefined
      ? 'La Rosa dei gusti'
      : `${seoTitle} - La Rosa dei gusti`;
  const seoTitleInject = seoTitleString || 'La Rosa dei gusti';
  const seoDescriptionInject =
    seoDescription || 'Siamo gli architetti del sapore';
  const seoUrlInject = `https://larosadeigusti.com${pathname}`;

  return (
    <Helmet>
      <html lang={locale} />
      <meta property="og:type" content="website" />
      <title>{seoTitleInject}</title>
      <meta property="og:title" content={seoTitleInject} />
      <meta property="twitter:title" content={seoTitleInject} />
      ,
      <meta name="description" content={seoDescriptionInject} />
      <meta property="og:description" content={seoDescriptionInject} />
      <meta property="twitter:description" content={seoDescriptionInject} />
      <meta property="og:image" content={seoImage || url} />
      <meta property="twitter:image" content={seoImage || url} />
      <meta property="og:url" content={seoUrlInject} />
      <meta property="twitter:url" content={seoUrlInject} />
      <meta
        name="facebook-domain-verification"
        content="t9aygvntksly7mw8rfo2jrerk1s4qr"
      />
    </Helmet>
  );
};
